import type { SortDirection } from "./binning";

export const DEFAULT_SORTING_OPTIONS = {
  is_external: "asc",
  departure_time: "asc",
  price_in_cents: "asc"
} satisfies Record<string, SortDirection>;

// Used by the binning strategy to determine which departures are competing with each other
export const TIME_WINDOW_IN_MINUTES = 15;
